import { render, staticRenderFns } from "./platformNationalManagement.vue?vue&type=template&id=4ce9f18a&scoped=true&"
import script from "./platformNationalManagement.vue?vue&type=script&lang=js&"
export * from "./platformNationalManagement.vue?vue&type=script&lang=js&"
import style0 from "./platformNationalManagement.vue?vue&type=style&index=0&id=4ce9f18a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce9f18a",
  null
  
)

export default component.exports